import React, { Component } from 'react';
import { Grid, findMatch } from 'react-flexr';
import Counter from './counter';
import StyleSheet from 'stilr';
import { event } from '../../utils/tracking';

import { on, off } from 'dom-helpers/events';
import { FAIcon } from '../icons';

const styles = StyleSheet.create({
  panel: {
    position: 'relative',
    overflow: 'hidden',
    paddingTop: 46
  },

  filterText: {
    margin: '15px 0',
    padding: '0 15px',
    fontSize: 14
  },

  searchBtn: {
    margin: '15px 0',
    padding: '0 15px'
  }
});

export default class SearchPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchOpen: !findMatch('palm')
    };
  }

  componentDidMount() {
    this.stickyHeader();
  }

  componentWillUnmount() {
    off(window, 'scroll', this.onScroll);
  }

  onSearch = val => {
    const searchOpen = typeof val === 'boolean' ? val : !this.state.searchOpen;
    this.setState({ searchOpen });
    if (__CLIENT__ && !searchOpen) {
      window.scrollTo(0, 0);
    }
    event(
      searchOpen
        ? {
            path: 'search/expand',
            title: 'Filtrer...'
          }
        : {
            path: 'search/execute',
            title: 'Søg'
          }
    );
  };

  onScroll = () => {
    const sticky = this._headerOffset < window.scrollY;
    if (this.state.sticky !== sticky) {
      this.setState({ sticky });
    }
  };

  stickyHeader() {
    on(window, 'scroll', this.onScroll);
  }

  render() {
    const { searchOpen } = this.state;
    const { results, filter, children, filterTexts = [], title, displayAddress } = this.props;

    const isPalm = findMatch('palm');
    const filterText = filterTexts.length ? filterTexts.join(', ') : null;

    const sticky = this.state.sticky && isPalm;

    return (
      <div className={`panel ${styles.panel}`}>
        {results && results.size ? (
          <Counter
            ref={node => {
              if (node) {
                // if (!this._headerOffset) {
                const pos = node.getPosition();
                this._headerOffset = pos ? pos.top : 0;
                // }
              }
              return (this._header = node);
            }}
            sticky={sticky}
            toggleSearch={this.onSearch}
            label={title || 'Resultater'}
            value={
              (typeof filter === 'function' ? filter(results) : results).size
            }
            total={results.size}
          />
        ) : null}



        {displayAddress ? <Grid style={isPalm ? { marginBottom: 0 } : null}>{children.map((child) => {
          return child.props.alwaysDisplay || searchOpen ? child : null;
        })}</Grid> : null}
        
        {!isPalm && displayAddress && searchOpen && filterText ? (
          <div className={styles.filterText}>
            {filterText.substr(0, 1).toUpperCase() + filterText.substr(1)}
          </div>
        ) : null}

        {!displayAddress && searchOpen ? (
          <Grid style={isPalm ? { marginBottom: 0 } : null}>{children}</Grid>
        ) : !displayAddress && filterText ? (
          <div className={styles.filterText}>
            {filterText.substr(0, 1).toUpperCase() + filterText.substr(1)}
          </div>
        ) : null}

        {isPalm ? (
          <div className={styles.searchBtn}>
            <span
              className={'btn btn-primary btn-block btn-sm'}
              onClick={this.onSearch}
            >
              {FAIcon(searchOpen ? 'search' : 'sliders')}{' '}
              {searchOpen ? 'Søg' : 'Filtrer...'}
            </span>
          </div>
        ) : null}
      </div>
    );
  }
}
